import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const CountriesOfUse = (props: Props) => (
  <FilterAutocomplete
    label="Country of Use"
    fieldName={'countryOfUse'}
    fieldPath={'productInformation.countryOfUse'}
  />
)
